import {connect} from "react-redux";
import {
  getDropDownsList, 
  addDropDown, 
  updateDropDown, 
  deleteDropDown, 
} from '../actions/actions-drop-downs';
import {
  GET_REFERRALSOURCE_LIST
  , ADD_REFERRALSOURCE
  , UPDATE_REFERRALSOURCE
  , DELETE_REFERRALSOURCE
} from '../actions/action-constants';
import ReferralSources from '../components/settings/referral-sources';
const mapStateToProps = (state, ownProps) => {
  return {
    referralsources: state.referralsourcesR
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getReferralSources: (params) => {
      dispatch(getDropDownsList( params, GET_REFERRALSOURCE_LIST) );}
    , addReferralSources: (params) => {
      dispatch(addDropDown(params, ADD_REFERRALSOURCE)).then(() => dispatch(getDropDownsList( params, GET_REFERRALSOURCE_LIST) ) )  ;}
    , updateReferralSources: (id, params) => {
      dispatch(updateDropDown(id, params, UPDATE_REFERRALSOURCE)).then(() => dispatch(getDropDownsList( params, GET_REFERRALSOURCE_LIST) ) )  ;}
    , deleteReferralSources: (id, params) => {
      dispatch(deleteDropDown(id, params, DELETE_REFERRALSOURCE)).then(() => dispatch(getDropDownsList( params, GET_REFERRALSOURCE_LIST) ) )  ;}
  };
};
const ReferralSourcesListContainer = connect(mapStateToProps, mapDispatchToProps)(ReferralSources);
export default ReferralSourcesListContainer;